function setObj(data, key,setData) {
    if(typeof(key) === 'string'){
        key = key.split('.')
    }
    let $key = key.splice(0,1)[0];
    if (typeof (data[$key]) === 'object' && key.length > 0) {
        setObj(data[$key],key,setData);
    } else {
        data[$key] = setData
    }
}
export {setObj}
